var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlassBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 5.90625C9.84375 4.45898 9.05664 3.13867 7.8125 2.40234C6.54297 1.66602 4.99414 1.66602 3.75 2.40234C2.48047 3.13867 1.71875 4.45898 1.71875 5.90625C1.71875 7.37891 2.48047 8.69922 3.75 9.43555C4.99414 10.1719 6.54297 10.1719 7.8125 9.43555C9.05664 8.69922 9.84375 7.37891 9.84375 5.90625ZM9.05664 10.0703C8.14258 10.7812 7 11.1875 5.78125 11.1875C2.86133 11.1875 0.5 8.82617 0.5 5.90625C0.5 3.01172 2.86133 0.625 5.78125 0.625C8.67578 0.625 11.0625 3.01172 11.0625 5.90625C11.0625 7.15039 10.6309 8.29297 9.91992 9.20703L13.0684 12.3555L13.5 12.7871L12.6367 13.625L12.2051 13.1934L9.05664 10.0449V10.0703Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassBlue);
export default __webpack_public_path__ + "static/media/magnifying-glass-blue.b01d9a92f36af0e6a7457071ef722ba5.svg";
export { ForwardRef as ReactComponent };